function toggleContainerEnergyLabel(e) {
  var container = document.querySelector(".container-energy-class");
  if (container.style.display !== "flex") {
    container.style.display = "flex";
  } else {
    container.style.display = "none";
  }
}

function closeContainerEnergyLabel(event, element) {
  if (event.target === element) {
    var container = document.querySelector(".container-energy-class");
    container.style.display = "none";
  }
}
